import { Link } from 'react-router-dom';
import Logo from '../components/Logo';

const MINT      = '66n7k4scKK2ggsimgoTZEfFW4QYhk7U9DsLcEkD2nrVt';
const SOLSCAN   = `https://solscan.io/token/${MINT}`;
const STREAMFLOW_500M = 'https://app.streamflow.finance/contract/solana/mainnet/DRSyyjMX6EDLfKxd9W9aUeaLDVD5uQPkVRHmyRGxwaWn';
const STREAMFLOW_100M = 'https://app.streamflow.finance/contract/solana/mainnet/ETbW4Uv2n6MctDyCGFfDrVwJYkm1egaJpuLSK9TMEtVc';
const STREAMFLOW_250M = 'https://app.streamflow.finance/contract/solana/mainnet/6cT6C6QSx4ouHg3WtQmjt77v8zsakbESt7HheH6wQHMB';
const RAYDIUM_PAIR    = 'https://dexscreener.com/solana/fyahwxkrncjwyurjfxxuoxecrm1bhwobfmvc4dv8qppl';

const stat = (label, value, sub) => (
    <div style={{
        background: 'rgba(255,255,255,0.05)',
        border: '1px solid rgba(255,193,7,0.2)',
        borderRadius: '16px',
        padding: '28px 24px',
        textAlign: 'center',
    }}>
        <div style={{ fontSize: '2rem', fontWeight: 700, color: '#ffc107', marginBottom: '6px' }}>{value}</div>
        <div style={{ fontSize: '1rem', color: '#fff', fontWeight: 600, marginBottom: sub ? '4px' : 0 }}>{label}</div>
        {sub && <div style={{ fontSize: '0.8rem', color: 'rgba(255,255,255,0.5)' }}>{sub}</div>}
    </div>
);

function Token() {
    return (
        <div style={{
            minHeight: '100vh',
            background: 'linear-gradient(180deg, #12121a 0%, #1a1a2e 50%, #12121a 100%)',
            color: '#ffffff',
        }}>
            {/* Background orbs */}
            <div style={{ position: 'fixed', top: '-20%', right: '-10%', width: '600px', height: '600px', background: 'radial-gradient(circle, rgba(255,193,7,0.15) 0%, transparent 70%)', borderRadius: '50%', pointerEvents: 'none', zIndex: 0 }} />
            <div style={{ position: 'fixed', bottom: '-30%', left: '-10%', width: '500px', height: '500px', background: 'radial-gradient(circle, rgba(255,193,7,0.1) 0%, transparent 70%)', borderRadius: '50%', pointerEvents: 'none', zIndex: 0 }} />

            {/* Header */}
            <header style={{ padding: '24px 40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', maxWidth: '1100px', margin: '0 auto', position: 'relative', zIndex: 10 }}>
                <Link to="/"><Logo size="medium" dark={false} /></Link>
                <Link to="/login" style={{ padding: '12px 28px', background: 'linear-gradient(135deg, #ffc107 0%, #ff9800 100%)', color: '#000', borderRadius: '50px', textDecoration: 'none', fontWeight: 600, fontSize: '0.95rem' }}>
                    Get Started
                </Link>
            </header>

            {/* Main content */}
            <main style={{ maxWidth: '1100px', margin: '0 auto', padding: '40px 24px 80px', position: 'relative', zIndex: 1 }}>

                {/* Hero */}
                <div style={{ textAlign: 'center', marginBottom: '64px' }}>
                    <img src="/ybee-logo.png" alt="YOUBEE" style={{ width: '96px', height: '96px', borderRadius: '50%', marginBottom: '24px', border: '3px solid rgba(255,193,7,0.4)' }} />
                    <h1 style={{ fontSize: 'clamp(2.2rem, 5vw, 3.5rem)', fontWeight: 800, margin: '0 0 16px', background: 'linear-gradient(135deg, #ffc107, #ff9800)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                        YOUBEE Token
                    </h1>
                    <p style={{ fontSize: '1.2rem', color: 'rgba(255,255,255,0.7)', maxWidth: '640px', margin: '0 auto 32px', lineHeight: 1.6 }}>
                        The utility token of the You Bee UBI platform. Every YOUBEE transfer carries a 5% fee — automatically funding real hourly USDC distributions to verified US residents.
                    </p>
                    <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
                        <a href={SOLSCAN} target="_blank" rel="noreferrer" style={{ padding: '12px 28px', background: 'linear-gradient(135deg, #ffc107 0%, #ff9800 100%)', color: '#000', borderRadius: '50px', textDecoration: 'none', fontWeight: 600 }}>
                            View on Solscan
                        </a>
                        {RAYDIUM_PAIR ? (
                            <a href={RAYDIUM_PAIR} target="_blank" rel="noreferrer" style={{ padding: '12px 28px', border: '2px solid rgba(255,193,7,0.5)', color: '#ffc107', borderRadius: '50px', textDecoration: 'none', fontWeight: 600 }}>
                                Trade on DexScreener
                            </a>
                        ) : (
                            <span style={{ padding: '12px 28px', border: '2px solid rgba(255,255,255,0.15)', color: 'rgba(255,255,255,0.4)', borderRadius: '50px', fontWeight: 600, fontSize: '0.95rem' }}>
                                Raydium Pair — Coming Soon
                            </span>
                        )}
                    </div>
                </div>

                {/* Stats grid */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', marginBottom: '64px' }}>
                    {stat('Total Supply', '1,000,000,000', 'Fixed — mint disabled')}
                    {stat('Network', 'Solana', 'Token-2022 standard')}
                    {stat('Transfer Fee', '5%', '2.5% UBI pool · 2.5% operations')}
                    {stat('Decimals', '6', null)}
                </div>

                {/* Token Distribution */}
                <section style={{ marginBottom: '64px' }}>
                    <h2 style={{ fontSize: '1.8rem', fontWeight: 700, marginBottom: '24px', textAlign: 'center' }}>Token Distribution</h2>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '16px' }}>
                        {[
                            { pct: '50%', label: '500,000,000 YOUBEE', desc: 'Locked 1 year + 2 year linear vest', badge: 'LOCKED', badgeColor: '#4caf50', link: STREAMFLOW_500M },
                            { pct: '25%', label: '250,000,000 YOUBEE', desc: 'Ecosystem reserve — locked on Streamflow', badge: 'LOCKED', badgeColor: '#4caf50', link: STREAMFLOW_250M },
                            { pct: '10%', label: '100,000,000 YOUBEE', desc: 'Raydium liquidity pool — locked 2 years', badge: 'LOCKED', badgeColor: '#4caf50', link: STREAMFLOW_100M },
                            { pct: '10%', label: '100,000,000 YOUBEE', desc: 'Founder allocation', badge: 'FOUNDERS', badgeColor: '#ffc107', link: null },
                            { pct: '5%',  label: '50,000,000 YOUBEE',  desc: 'Ecosystem & operations', badge: 'ECOSYSTEM', badgeColor: '#2196f3', link: null },
                        ].map(({ pct, label, desc, badge, badgeColor, link }) => (
                            <div key={pct} style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '16px', padding: '24px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                                    <span style={{ fontSize: '2rem', fontWeight: 800, color: '#ffc107' }}>{pct}</span>
                                    <span style={{ fontSize: '0.7rem', fontWeight: 700, background: badgeColor, color: '#000', borderRadius: '20px', padding: '3px 10px', letterSpacing: '0.05em' }}>{badge}</span>
                                </div>
                                <div style={{ fontWeight: 600, marginBottom: '4px' }}>{label}</div>
                                <div style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.5)', marginBottom: link ? '8px' : 0 }}>{desc}</div>
                                {link && <a href={link} target="_blank" rel="noreferrer" style={{ fontSize: '0.8rem', color: '#4caf50', textDecoration: 'none' }}>View lock on Streamflow ↗</a>}
                            </div>
                        ))}
                    </div>
                </section>

                {/* Purpose */}
                <section style={{ marginBottom: '64px', background: 'rgba(255,193,7,0.08)', border: '1px solid rgba(255,193,7,0.25)', borderRadius: '20px', padding: '40px' }}>
                    <h2 style={{ fontSize: '1.8rem', fontWeight: 700, marginBottom: '16px', textAlign: 'center' }}>Why YOUBEE Exists</h2>
                    <p style={{ fontSize: '1.1rem', color: 'rgba(255,255,255,0.8)', lineHeight: 1.8, maxWidth: '720px', margin: '0 auto', textAlign: 'center' }}>
                        Every YOUBEE transaction carries a 5% fee, split equally between two purposes: 2.5% flows directly into the You Bee General Pool, funding hourly USDC distributions to verified US residents, and 2.5% covers You Bee's marketing and legal operations. The more YOUBEE trades, the more UBI gets distributed. Holding and trading YOUBEE is a direct act of participation in a live, functioning basic income network.
                    </p>
                </section>

                {/* Contract info */}
                <section style={{ textAlign: 'center' }}>
                    <h2 style={{ fontSize: '1.4rem', fontWeight: 700, marginBottom: '16px' }}>Contract Address</h2>
                    <div style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '12px', padding: '16px 24px', display: 'inline-block', fontFamily: 'monospace', fontSize: '0.9rem', color: '#ffc107', wordBreak: 'break-all', maxWidth: '100%' }}>
                        {MINT}
                    </div>
                    <div style={{ marginTop: '24px', display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
                        <a href={SOLSCAN} target="_blank" rel="noreferrer" style={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none', fontSize: '0.9rem' }}>
                            View on Solscan ↗
                        </a>
                        <a href={STREAMFLOW_500M} target="_blank" rel="noreferrer" style={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none', fontSize: '0.9rem' }}>
                            500M Lock on Streamflow ↗
                        </a>
                        <a href={STREAMFLOW_250M} target="_blank" rel="noreferrer" style={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none', fontSize: '0.9rem' }}>
                            250M Lock on Streamflow ↗
                        </a>
                        <a href={STREAMFLOW_100M} target="_blank" rel="noreferrer" style={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none', fontSize: '0.9rem' }}>
                            100M LP Lock on Streamflow ↗
                        </a>
                    </div>
                </section>
            </main>
        </div>
    );
}

export default Token;
